import React from 'react';

export function Tooltip({label,side='top',children,style,...rest}){
  const [show,setShow]=React.useState(false);
  const pos=side==='top'?{bottom:'calc(100% + 8px)',left:'50%',transform:'translateX(-50%)'}
    :side==='bottom'?{top:'calc(100% + 8px)',left:'50%',transform:'translateX(-50%)'}
    :side==='left'?{right:'calc(100% + 8px)',top:'50%',transform:'translateY(-50%)'}
    :{left:'calc(100% + 8px)',top:'50%',transform:'translateY(-50%)'};
  return React.createElement('span',{style:{position:'relative',display:'inline-flex',...style},onMouseEnter:()=>setShow(true),onMouseLeave:()=>setShow(false),...rest},
    children,
    show?React.createElement('span',{role:'tooltip',
      style:{position:'absolute',zIndex:200,whiteSpace:'nowrap',padding:'6px var(--space-4)',background:'var(--surface-inverse)',color:'var(--white)',
        fontFamily:'var(--font-text)',fontSize:'var(--fs-2xs)',borderRadius:'var(--radius-sm)',boxShadow:'var(--shadow-md)',pointerEvents:'none',...pos}},label):null);
}
